<div class="grid grid-cols-5 gap-4 p-3">
  <div class="col-span-3">
    <div class="">
      <section class="mb-4">
        <div
          class="flex flex-wrap gap-9 py-3 pr-3 pl-4 rounded-xl bg-neutral-100 border-neutral-100"
          role="banner"
          aria-label="Welcome banner with last login information"
        >
          <img
            loading="lazy"
            src="/images/dashboard/computer.png"
            class="object-contain shrink-0 aspect-square w-[65px]"
            alt="Welcome banner illustration"
          />
          <div
            class="flex flex-col grow shrink-0 my-auto basis-0 w-fit max-md:max-w-full"
          >
            <div class="flex items-center">
              <h1 class="flex-auto text-lg font-extrabold text-neutral-600">
                Hello! Welcome Again.
              </h1>

              <img
                loading="lazy"
                src="/images/dashboard/clock.svg"
                class="object-contain shrink-0 w-6 aspect-square size-5"
                alt=""
              />
              <span class="my-auto text-xs basis-auto">
                Last Login:
                <strong>{{
                  dashboardData?.lastLogin | date: "dd/MM/yyyy"
                }}</strong>
              </span>
            </div>
            <div
              class="mt-1 text-sm font-light text-neutral-600 max-md:max-w-full"
            >
              Track all your request status and keep an eye on other relents
              impacting your business.
            </div>
          </div>
        </div>
      </section>
      <section
        *ngIf="hasDetailedPerm('Dashboard', 'Vendor Lifecycle Overview', 'read')"
        class="w-full bg-zinc-100 border-neutral-100 max-md:max-w-full"
        role="region"
        aria-labelledby="overview-title"
      >
        <div class="section-header flex p-2">
          <h2
            id="overview-title"
            class="self-start text-base font-extrabold text-zinc-800 flex items-center gap-1"
          >
            Vendor Lifecycle Overview
            <mat-icon
              class="!text-[18px] !h-[18px] !w-[18px] cursor-pointer text-gray-400"
              matTooltipPosition="above"
              matTooltip="Tracks total vendors by lifecycle status"
            >info_outline</mat-icon>
          </h2>
          <!-- <a class="ms-auto self-end text-sm text-black hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            role="link">
            View All
          </a> -->
        </div>
        <div class="p-5 bg-[#ececec]">
          <div class="flex gap-5 justify-between">
            <div
              class="flex flex-col px-3 py-2.5 text-white rounded-xl bg-slate-800"
              role="status"
              aria-label="All Vendors Count"
            >
              <div class="text-sm max-md:mr-1">All Vendors</div>
              <div
                class="text-3xl font-bold flex justify-center cursor-pointer"
                (click)="onVendorInventoryRedirect('')"
              >
                {{ dashboardData?.vendorLifecycleOverview?.totalActiveVendors }}
              </div>
            </div>
            <div class="grid grid-cols-5 divide-x flex-1 mt-3.5">
              <div
                class="flex flex-col items-center font-semibold text-[11px] text-[#000]"
              >
                In Progress
                <div
                  class="mt-2 text-3xl font-bold text-[#FFBD40] cursor-pointer"
                  (click)="onVendorInventoryRedirect('in-progress')"
                >
                  {{
                    dashboardData?.vendorLifecycleOverview?.statusCounts?.[
                      "in-progress"
                    ]
                  }}
                </div>
              </div>
              <div
                class="flex flex-col items-center text-[11px] font-semibold text-[#000]"
              >
                Active
                <div
                  class="mt-2 text-3xl font-bold text-[#00B25A] cursor-pointer"
                  (click)="onVendorInventoryRedirect('active')"
                >
                  {{
                    dashboardData?.vendorLifecycleOverview?.statusCounts?.active
                  }}
                </div>
              </div>
              <div
                class="flex flex-col items-center text-[11px] font-semibold text-[#000]"
              >
                In Active
                <div
                  class="mt-2 text-3xl font-bold text-[#D61409] cursor-pointer"
                  (click)="onVendorInventoryRedirect('inactive')"
                >
                  {{
                    dashboardData?.vendorLifecycleOverview?.statusCounts
                      ?.inactive
                  }}
                </div>
              </div>
              <div
                class="flex flex-col items-center text-[11px] font-semibold text-[#000]"
              >
                Offboarded
                <div
                  class="mt-2 text-3xl font-bold text-[#F86522] cursor-pointer"
                  (click)="onVendorInventoryRedirect('offboarded')"
                >
                  {{
                    dashboardData?.vendorLifecycleOverview?.statusCounts
                      ?.offboarded
                  }}
                </div>
              </div>
              <div
                class="flex flex-col items-center text-[11px] text-nowrap font-semibold text-[#000]"
              >
                Past Due
                <div class="mt-2 text-3xl font-bold text-dark-500">
                  {{ dashboardData?.vendorLifecycleOverview?.dueDateCount }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        *ngIf="hasDetailedPerm('Dashboard', 'Business Risk Overview', 'read')"
        class="w-full bg-zinc-100 border-neutral-100 max-md:max-w-full mt-3"
        role="region"
        aria-labelledby="overview-title"
      >
        <div class="section-header flex p-2 items-center">
          <h2
            id="overview-title"
            class="self-start text-base font-extrabold text-zinc-800 flex items-center gap-1"
          >
            Business Risk Overview
            <mat-icon
              class="!text-[18px] !h-[18px] !w-[18px] cursor-pointer text-gray-400"
              [matMenuTriggerFor]="riskMenu"
            >info_outline</mat-icon>
          </h2>
        </div>
        <mat-menu #riskMenu="matMenu" class="risk-popover">
            <div class="px-4 py-2" (click)="$event.stopPropagation()">
              <p class="text-sm text-gray-700 mb-2">
                Shows vendor risk distribution across tiers
              </p>
              <h4 class="font-bold text-[#800408] mb-2 border-b pb-1">
                Rating Range
              </h4>
              <table class="w-full text-sm border-collapse">
                <thead>
                  <tr class="bg-[#c0392b] text-white">
                    <th class="border border-gray-300 p-2 text-left">
                      Risk Score
                    </th>
                    <th class="border border-gray-300 p-2 text-left">
                      Risk Score Band
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="border border-gray-300 p-2">86 - 100</td>
                    <td class="border border-gray-300 p-2">Low Risk</td>
                  </tr>
                  <tr>
                    <td class="border border-gray-300 p-2">73 - 85</td>
                    <td class="border border-gray-300 p-2">Moderate Risk</td>
                  </tr>
                  <tr>
                    <td class="border border-gray-300 p-2">56 - 72</td>
                    <td class="border border-gray-300 p-2">Average Risk</td>
                  </tr>
                  <tr>
                    <td class="border border-gray-300 p-2">34 - 55</td>
                    <td class="border border-gray-300 p-2">
                      Below Average Risk
                    </td>
                  </tr>
                  <tr>
                    <td class="border border-gray-300 p-2">0 - 33</td>
                    <td class="border border-gray-300 p-2">High Risk</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-menu>

          <mat-menu #riskMenu="matMenu" class="risk-table-menu">
  <div (click)="$event.stopPropagation()" class="p-2">
    <table class="risk-tooltip-table">
      <thead>
        <tr>
          <th>Score Range</th>
          <th>Indicator</th>
        </tr>
      </thead>
      <tbody>
        <tr class="row-low"><td>86-100</td><td>Low Risk</td></tr>
        <tr class="row-mod"><td>73-85</td><td>Moderate Risk</td></tr>
        <tr class="row-avg"><td>56-72</td><td>Average Risk</td></tr>
        <tr class="row-below"><td>34-55</td><td>Below Average</td></tr>
        <tr class="row-high"><td>Less than 33</td><td>High Risk</td></tr>
      </tbody>
    </table>
  </div>
</mat-menu>
        <div class="p-2 bg-[#ececec]">
          <div class="flex items-center justify-between p-4 pb-0">
            <div class="w-full risk-band-chart">
              <ul id="progressbar">
                <li class="critical cursor-pointer">
                  <span
                    class="count"
                    (click)="onBusinessRiskRedirect('high risk')"
                    >{{ getRiskOverviewCount("high risk") }}</span
                  >
                  <span class="arrow"></span>
                  <span class="value text-[#000]">High Risk</span>
                </li>
                <li class="caution cursor-pointer">
                  <span
                    class="count"
                    (click)="onBusinessRiskRedirect('below average risk')"
                    >{{ getRiskOverviewCount("below average risk") }}</span
                  >
                  <span class="arrow"></span>
                  <span class="value text-[#000]">Below Average Risk</span>
                </li>
                <li class="normal cursor-pointer">
                  <span
                    class="count"
                    (click)="onBusinessRiskRedirect('average risk')"
                    >{{ getRiskOverviewCount("average risk") }}</span
                  >
                  <span class="arrow"></span>
                  <span class="value text-[#000]">Average Risk</span>
                </li>
                <li class="stable cursor-pointer">
                  <span
                    class="count"
                    (click)="onBusinessRiskRedirect('moderate risk')"
                    >{{ getRiskOverviewCount("moderate risk") }}</span
                  >
                  <span class="arrow"></span>
                  <span class="value text-[#000]">Moderate Risk</span>
                </li>
                <li class="secure cursor-pointer">
                  <span
                    class="count"
                    (click)="onBusinessRiskRedirect('low risk')"
                    >{{ getRiskOverviewCount("low risk") }}</span
                  >
                  <span class="arrow"></span>
                  <span class="value text-[#000]">Low Risk</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="">
      <section
        *ngIf="hasDetailedPerm('Dashboard', 'Open Activity Status', 'read')"
        class="relative w-full bg-zinc-100 border-neutral-100 max-md:max-w-full"
        role="region"
        aria-labelledby="overview-title"
      >
        <div class="section-header flex justify-between p-2">
          <h2
            id="overview-title"
            class="self-start text-base font-extrabold text-zinc-800 flex items-center gap-1"
          >
            Open Activity Status
            <mat-icon
              class="!text-[18px] !h-[18px] !w-[18px] cursor-pointer text-gray-400"
              matTooltipPosition="above"
              matTooltip="Count of Assessment and Risk Tiering at each stage"
            >info_outline</mat-icon>
          </h2>
          <mat-form-field
            class="custom-small-select"
            appearance="fill"
            floatLabel="always"
          >
            <mat-select
              placeholder="Select"
              class="type-select text-[#000]"
              [value]="openActivityStatusType"
              (selectionChange)="onOpenAssessementStatusChange($event)"
            >
              <mat-option se [value]="'assessment'">Assessment</mat-option>
              <mat-option [value]="'rtt'">Risk Tiering</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="p-2 bg-[#ececec] pb-5">
          <app-bar-chart
            (dataEvent)="onOpenActStatusBarClick($event, 'assessment')"
            *ngIf="openActivityStatusType === 'assessment'"
            [data]="dashboardData?.assessmentStatus"
            barColor="bg-blue-500"
            [barColors]="{
              'Not Started': '#D61409',
              'In Progress': '#FFBD40',
              'Under Evaluation': '#F86522',
              'Under Review': '#3B82F6',
              Completed: '#00B25A',
              Rejected: '#D61409',
            }"
          >
          </app-bar-chart>

          <app-bar-chart
            *ngIf="openActivityStatusType === 'rtt'"
            (dataEvent)="onOpenActStatusBarClick($event, 'risk-tiering')"
            [data]="dashboardData.riskTieringStatus"
            [barColors]="{
              'Not Started': '#D61409',
              'In Progress': '#FFBD40',
              'Under Evaluation': '#F86522',
              'Under Review': '#3B82F6',
              Completed: '#00B25A',
              Rejected: '#D61409',
            }"
          >
          </app-bar-chart>
        </div>
      </section>
    </div>
    <div class="">
      <div class="flex">
        <section
          *ngIf="hasDetailedPerm('Dashboard', 'Inherent Risk Overview', 'read')"
          class="w-full bg-zinc-100 border-neutral-100 max-md:max-w-full"
          role="region"
          aria-labelledby="overview-title"
        >
          <div class="section-header flex justify-between p-2">
            <h2
              id="overview-title"
              class="self-start text-base font-extrabold text-zinc-800 flex items-center gap-1"
            >
              Inherent Risk Overview
              <mat-icon
                class="!text-[18px] !h-[18px] !w-[18px] cursor-pointer text-gray-400"
                matTooltipPosition="above"
                matTooltip="Count of inherent risk by severity across Assessment and Risk Tiering"
              >info_outline</mat-icon>
            </h2>
            <mat-form-field
              class="custom-small-select"
              appearance="fill"
              floatLabel="always"
            >
              <mat-select
                placeholder="Select"
                class="type-select text-[#000]"
                [value]="inherentRiskOverviewType"
                (selectionChange)="onInherentRiskOverviewChange($event)"
              >
                <mat-option [value]="'assessment'">Assessment</mat-option>
                <mat-option [value]="'rtt'">Risk Tiering</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="p-2 bg-[#ececec] h-[193px] text-[#0000]">
            <app-donut-chart
              *ngIf="inherentRiskOverviewData"
              [data]="inherentRiskOverviewData"
              [colorMap]="{
                High: '#D61409',
                Medium: '#FFBD40',
                Low: '#00B25A',
              }"
              (dataEvent)="onInherentOverviewChange($event)"
            ></app-donut-chart>
          </div>
        </section>
        <section
          *ngIf="hasDetailedPerm('Dashboard', 'Residual Risk Overview', 'read')"
          class="w-full bg-zinc-100 border-neutral-100 max-md:max-w-full ms-2"
          role="region"
          aria-labelledby="overview-title"
        >
          <div class="section-header flex p-2 h-[43px]">
            <h2
              id="overview-title"
              class="self-start text-base font-extrabold text-zinc-800 flex items-center gap-1"
            >
              Residual Risk Overview
              <mat-icon
                class="!text-[18px] !h-[18px] !w-[18px] cursor-pointer text-gray-400"
                matTooltipPosition="above"
                matTooltip="Count of residual risk by severity in Assessment"
              >info_outline</mat-icon>
            </h2>
          </div>
          <div class="p-2 bg-[#ececec] h-[193px]">
            <app-donut-chart
              *ngIf="residualRiskOverviewData"
              [data]="residualRiskOverviewData"
              [colorMap]="{
                High: '#D61409',
                Medium: '#FFBD40',
                Low: '#00B25A',
              }"
              (dataEvent)="onRiskRiskOverviewChange($event)"
            ></app-donut-chart>
          </div>
        </section>
      </div>
      <div class="flex" *ngIf="false">
        <section
          *ngIf="hasDetailedPerm('Dashboard', 'Inherent Risk Overview', 'read')"
          class="w-full bg-zinc-100 border-neutral-100 max-md:max-w-full"
          role="region"
          aria-labelledby="overview-title"
        >
          <div class="section-header flex justify-between p-2">
            <h2
              id="overview-title"
              class="self-start text-base font-extrabold text-zinc-800"
            >
              Evidence Overview
            </h2>
            <mat-form-field
              class="custom-small-select"
              appearance="fill"
              floatLabel="always"
            >
              <mat-select
                placeholder="Select"
                class="type-select text-[#000]"
                [value]="evidenceOverviewType"
                (selectionChange)="onEvidenceOverviewChange($event)"
              >
                <mat-option [value]="'assessment'">Assessment</mat-option>
                <mat-option [value]="'rtt'">Risk Tiering</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="p-2 bg-[#ececec] h-[193px]">
            <app-donut-chart
              *ngIf="evidenceOverviewData"
              [data]="evidenceOverviewData"
              [colorMap]="{
                Expired: '#D61409',
                Active: '#00B25A',
              }"
              (dataEvent)="onEvidenceOverviewChange($event)"
            ></app-donut-chart>
          </div>
        </section>
        <section
          *ngIf="
            false &&
            hasDetailedPerm('Dashboard', 'Inherent Risk Overview', 'read')
          "
          class="w-full bg-zinc-100 border-neutral-100 max-md:max-w-full ms-2"
          role="region"
          aria-labelledby="overview-title"
        >
          <div class="section-header flex justify-between p-2">
            <h2
              id="overview-title"
              class="self-start text-base font-extrabold text-zinc-800"
            >
              Past Due Date Overview
            </h2>
            <mat-form-field
              class="custom-small-select"
              appearance="fill"
              floatLabel="always"
            >
              <mat-select
                placeholder="Select"
                class="type-select text-[#000]"
                [value]="pastDueDateOverviewType"
                (selectionChange)="onPastDueDateOverviewChange($event)"
              >
                <mat-option [value]="'assessment'">Assessment</mat-option>
                <mat-option [value]="'rtt'">Risk Tiering</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="p-2 bg-[#ececec] h-[193px]">
            <app-donut-chart
              *ngIf="pastDueDateOverviewData"
              [data]="pastDueDateOverviewData"
              [colorMap]="{
                High: '#D61409',
                Medium: '#FFBD40',
                Low: '#00B25A',
              }"
              (dataEvent)="onInherentOverviewChange($event)"
            ></app-donut-chart>
          </div>
        </section>
      </div>
      <div class="flex">
        <section
          *ngIf="hasDetailedPerm('Dashboard', 'Risk Status', 'read')"
          class="w-full bg-zinc-100 border-neutral-100 max-md:max-w-full"
          role="region"
          aria-labelledby="overview-title"
        >
          <div class="section-header flex p-2 justify-between">
            <h2
              id="overview-title"
              class="self-start text-base font-extrabold text-zinc-800 flex items-center gap-1"
            >
              Risk Summary Status
              <mat-icon
                class="!text-[18px] !h-[18px] !w-[18px] cursor-pointer text-gray-400"
                matTooltipPosition="above"
                matTooltip="Number of open and closed risk responses in Assessment and Risk Tiering"
              >info_outline</mat-icon>
            </h2>
            <mat-form-field
              class="custom-small-select"
              appearance="fill"
              floatLabel="always"
            >
              <mat-select
                placeholder="Select"
                class="type-select text-[#000]"
                [value]="riskStatusType"
                (selectionChange)="onriskStatusChange($event)"
              >
                <mat-option [value]="'assessment'">Assessment</mat-option>
                <mat-option [value]="'rtt'">Risk Tiering</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="p-2 bg-[#ececec]">
            <app-bar-chart
              (dataEvent)="onRiskStatusBarClick($event)"
              [data]="riskStatus"
              [barColors]="{
                Open: '#D61409',
                Closed: '#00B25A',
              }"
            ></app-bar-chart>
          </div>
        </section>
        <section
          *ngIf="hasDetailedPerm('Dashboard', 'Risk Response Overview', 'read')"
          class="w-full bg-zinc-100 border-neutral-100 max-md:max-w-full ms-2"
          role="region"
          aria-labelledby="overview-title"
        >
          <div class="section-header flex p-2 justify-between">
            <h2
              id="overview-title"
              class="self-start text-base font-extrabold text-zinc-800 flex items-center gap-1"
            >
              Risk Result Overview
              <mat-icon
                class="!text-[18px] !h-[18px] !w-[18px] cursor-pointer text-gray-400"
                matTooltipPosition="above"
                matTooltip="Distribution of closed risks by response: Reduced, Avoided, Ignored, Accepted, or Transferred"
              >info_outline</mat-icon>
            </h2>
            <mat-form-field
              class="custom-small-select"
              appearance="fill"
              floatLabel="always"
            >
              <mat-select
                placeholder="Select"
                class="type-select text-[#000]"
                [value]="riskResponseOverviewType"
                (selectionChange)="onRiskResponseOverviewChange($event)"
              >
                <mat-option [value]="'assessment'">Assessment</mat-option>
                <mat-option [value]="'rtt'">Risk Tiering</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="p-2 bg-[#ececec] h-[202px]">
            <app-donut-chart
              *ngIf="riskResultSummaryData"
              [data]="riskResultSummaryData"
              [colorMap]="{
                Reduced: '#00B25A',
                Avoided: '#7DD259',
                Ignored: '#F86522',
                Accepted: '#FFBD40',
                Transferred: '#3B82F6',
              }"
              (dataEvent)="onRiskResOverviewClick($event)"
            ></app-donut-chart>
          </div>
        </section>
      </div>
    </div>
  </div>

  <div class="col-span-2">
    <div class="">
      <section
        *ngIf="hasDetailedPerm('Dashboard', 'Vendor Count by Category', 'read')"
        class="w-full bg-zinc-100 border-neutral-100 max-md:max-w-full"
        role="region"
        aria-label="Risk Assessment Dashboard"
      >
        <div class="section-header flex p-2 justify-between">
          <h2
            id="overview-title"
            class="self-start text-base font-extrabold text-zinc-800 flex items-center gap-1"
          >
            Vendor Count
            <mat-icon
              class="!text-[18px] !h-[18px] !w-[18px] cursor-pointer text-gray-400"
              matTooltipPosition="above"
              matTooltip="Vendors grouped by category and department"
            >info_outline</mat-icon>
          </h2>
          <mat-form-field
            class="custom-small-select"
            appearance="fill"
            floatLabel="always"
          >
            <mat-select
              placeholder="Select"
              class="type-select text-[#000]"
              [value]="vendorCountType"
              (selectionChange)="onVendorCountTypeChange($event)"
            >
              <mat-option [value]="'Category'">Category</mat-option>
              <mat-option [value]="'Department'">Department</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-col p-2 bg-[#ececec]">
          <app-bar-chart
            (dataEvent)="onVendorCountByCatClick($event)"
            [data]="dashboardData?.vendorCategoryCounts"
            *ngIf="vendorCountType === 'Category'"
          ></app-bar-chart>
          <app-bar-chart
            (dataEvent)="onVendorCountByCatClick($event)"
            [data]="dashboardData?.departmentCounts"
            *ngIf="vendorCountType === 'Department'"
          ></app-bar-chart>
        </div>
      </section>

      <div class="">
        <section
          *ngIf="hasDetailedPerm('Dashboard', 'Risk Summary', 'read')"
          class="w-full bg-zinc-100 border-neutral-100 max-md:max-w-full"
          role="region"
          aria-label="Open Issue Summary"
        >
          <div class="section-header flex justify-between p-2">
            <h2 class="self-start text-base font-extrabold text-zinc-800 flex items-center gap-1">
              Risk Summary
              <mat-icon
                class="!text-[18px] !h-[18px] !w-[18px] cursor-pointer text-gray-400"
                matTooltipPosition="above"
                matTooltip="Count of Open Risk Flags across the risk levels"
              >info_outline</mat-icon>
            </h2>
            <mat-form-field
              class="custom-small-select"
              appearance="fill"
              floatLabel="always"
            >
              <mat-select
                placeholder="Select"
                class="type-select text-[#000]"
                [value]="riskSummaryType"
                (selectionChange)="onOpenRiskSummaryChange($event)"
              >
                <mat-option [value]="'assessment'">Assessment</mat-option>
                <mat-option [value]="'rtt'">Risk Tiering</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="relative p-2 bg-[#ececec] min-h-[200px]">
            <risk-summary-chart
              [class.hide-content]="isAllZero(riskSummary)"
              (dataEvent)="onRiskSummaryClick($event)"
              [chartData]="riskSummary"
            ></risk-summary-chart>
            <ng-container *ngIf="isAllZero(riskSummary)">
              <ng-container
                *ngTemplateOutlet="
                  noDataTemplate;
                  context: { text: 'No Records Found' }
                "
              ></ng-container>
            </ng-container>
          </div>
        </section>
      </div>

      <div class="">
        <section
          *ngIf="hasDetailedPerm('Dashboard', 'Recent Activities', 'read')"
          class="w-full bg-zinc-100 border-neutral-100 max-md:max-w-full"
          role="region"
          aria-label="Open Issue Summary"
        >
          <div class="section-header p-2 flex justify-between">
            <h2 class="self-start text-base font-extrabold text-zinc-800 flex items-center gap-1">
              Recent Activities
              <mat-icon
                class="!text-[18px] !h-[18px] !w-[18px] cursor-pointer text-gray-400"
                matTooltipPosition="above"
                matTooltip="Shows 10 most recent Assessment and Risk Tiering records with status"
              >info_outline</mat-icon>
            </h2>
            <mat-form-field
              class="custom-small-select"
              appearance="fill"
              floatLabel="always"
            >
              <mat-select
                placeholder="Select"
                class="type-select text-[#000]"
                [value]="recentActivityType"
                (selectionChange)="onRecentActivitiesChange($event)"
              >
                <mat-option [value]="'assessment'">Assessment</mat-option>
                <mat-option [value]="'rtt'">Risk Tiering</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="p-2 bg-[#ececec] relative min-h-[250px]">
            <div
              class="rounded-b-lg overflow-x-auto"
              [class.hide-content]="recentActivities?.length === 0"
            >
              <table class="w-full text-sm text-gray-700">
                <thead>
                  <tr class="border-b-2 border-gray-400">
                    <th
                      class="py-3 px-2 font-bold text-left border-r border-gray-400 text-nowrap"
                    >
                      Sr. No.
                    </th>
                    <th
                      class="py-3 px-2 font-bold border-r border-gray-400 text-center"
                    >
                      ID
                    </th>
                    <th
                      class="py-3 px-2 text-nowrap font-bold border-r border-gray-400 text-center"
                    >
                      Vendor Name
                    </th>

                    <th
                      class="py-3 px-2 text-nowrap font-bold text-left border-r border-gray-400"
                    >
                      Initiation Date
                    </th>
                    <th
                      class="py-3 px-2 text-nowrap font-bold text-center border-r border-gray-400"
                    >
                      Updated Date
                    </th>
                    <th
                      class="py-3 px-2 text-nowrap font-bold border-r border-gray-400 text-center"
                    >
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let activity of recentActivities;
                      index as i;
                      last as isLast
                    "
                    [ngClass]="{ 'border-b border-gray-400': !isLast }"
                  >
                    <td class="py-2 px-2 border-r border-gray-400 text-center">
                      {{ i + 1 }}
                    </td>
                    <td class="py-2 px-2 border-r border-gray-400">
                      <span class="text-nowrap">
                        <a
                          (click)="redirectRecentActivity(activity)"
                          class="text-primary font-semibold text-nowrap cursor-pointer text-center"
                        >
                          {{ activity.assessmentId || activity.rttId }}
                        </a>
                      </span>
                    </td>
                    <td class="py-2 px-2 border-r border-gray-400 text-nowrap">
                      {{ activity.vendorName }}
                    </td>

                    <td class="py-2 px-2 border-r border-gray-400 text-center">
                      {{ activity.creationDate | date: "dd/MM/yyyy" }}
                    </td>
                    <td class="py-2 px-2 border-r border-gray-400 text-center">
                      {{
                        activity.completionDate
                          ? (activity.completionDate | date: "dd/MM/yyyy")
                          : "--"
                      }}
                    </td>
                    <td
                      class="py-2 px-2 border-r border-gray-400 text-nowrap text-center {{
                        getStatusClass(activity.status)
                      }}"
                    >
                      {{ activity.status || "--" }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-container
              *ngIf="recentActivities?.length === 0; else activityTable"
            >
              <ng-container
                *ngTemplateOutlet="
                  noDataTemplate;
                  context: { text: 'No Recent Activities Found' }
                "
              ></ng-container>
            </ng-container>
            <ng-template #activityTable> </ng-template>
          </div>
        </section>
      </div>

      <!-- Re-Assessment Tracker (ported from ihcl-dev) -->
      <div class="">
        <section
          *ngIf="hasDetailedPerm('Dashboard', 'Re-assessment Tracker', 'read')"
          class="w-full bg-zinc-100 border-neutral-100 max-md:max-w-full"
          role="region"
          aria-label="Re-Assessment Tracker"
        >
          <div class="section-header flex p-2 justify-between items-center">
            <div class="flex items-center">
              <h2 class="self-start text-base font-extrabold text-zinc-800">
                Re-Assessment Tracker
              </h2>
              <mat-icon
                class="ml-1 cursor-pointer text-gray-500"
                matTooltip="Tracks re-assessment status of vendor Assessment & Risk Tiering with their current due status."
                matTooltipPosition="right"
                >info_outline</mat-icon
              >
            </div>
            <div class="flex items-center gap-2">
              <div class="relative flex items-center">
                <input
                  type="text"
                  placeholder="Search..."
                  [value]="reAssessmentSearchTerm"
                  (input)="onReAssessmentSearch($any($event.target).value)"
                  class="border border-gray-300 rounded px-2 py-1 text-xs w-24 sm:w-28 pr-6 focus:outline-none focus:ring-1 focus:ring-gray-400 bg-white"
                />
                <mat-icon
                  class="absolute right-1 text-gray-400 !text-base !w-4 !h-4 pointer-events-none"
                  >search</mat-icon
                >
              </div>
              <mat-form-field
                class="custom-small-select"
                appearance="fill"
                floatLabel="always"
              >
                <mat-select
                  placeholder="Status"
                  class="type-select text-[#000]"
                  [value]="reAssessmentStatusFilter"
                  (selectionChange)="onReAssessmentStatusChange($event.value)"
                >
                  <mat-option value="">All</mat-option>
                  <mat-option value="On Track">On Track</mat-option>
                  <mat-option value="Upcoming">Upcoming</mat-option>
                  <mat-option value="Due Soon">Due Soon</mat-option>
                  <mat-option value="Overdue">Overdue</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="p-2 bg-[#ececec] relative flex flex-col min-h-[200px]">
            <!-- Loading -->
            <div
              *ngIf="reAssessmentLoading"
              class="flex justify-center items-center py-10"
            >
              <span class="text-sm text-gray-400">Loading...</span>
            </div>

            <!-- List -->
            <ng-container *ngIf="!reAssessmentLoading">
              <div class="flex-1">
                <div
                  *ngFor="let item of reAssessmentData"
                  class="flex items-center justify-between px-3 py-2 bg-white mb-1.5 rounded-lg shadow-sm border border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer"
                  (click)="redirectToReAssessment()"
                >
                  <div class="flex flex-col gap-0.5 flex-1 min-w-0 mr-2">
                    <span
                      class="font-semibold text-sm text-primary truncate hover:underline cursor-pointer"
                      (click)="redirectToReAssessmentWithStatus(item); $event.stopPropagation()"
                      >{{ item.vendorName }}</span
                    >
                    <span class="text-xs text-gray-500">{{
                      item.nextDueDate | date: "dd/MM/yyyy"
                    }}</span>
                  </div>
                  <div class="flex items-center gap-1.5 shrink-0">
                    <span
                      class="text-[10px] font-bold px-2 py-0.5 rounded-full border"
                      [ngStyle]="{
                        color: getReAssessmentStatusColor(item.reassessmentStatus),
                        'border-color': getReAssessmentStatusColor(item.reassessmentStatus),
                        'background-color': getReAssessmentStatusBgColor(item.reassessmentStatus)
                      }"
                      >{{ item.reassessmentStatus }}</span
                    >
                    <span
                      class="text-[10px] font-bold rounded border inline-flex items-center justify-center px-1.5 whitespace-nowrap"
                      [ngStyle]="{
                        'background-color': '#FFFFFF',
                        'color': '#000000',
                        'border-color': '#D1D5DB',
                        'height': '18px'
                      }"
                      >{{ item.category === "RTT" ? "Risk Tiering" : "Assessment" }}</span
                    >
                  </div>
                </div>

                <!-- No data -->
                <ng-container *ngIf="reAssessmentData.length === 0">
                  <ng-container
                    *ngTemplateOutlet="
                      noDataTemplate;
                      context: { text: 'No Re-Assessments Found' }
                    "
                  ></ng-container>
                </ng-container>
              </div>

              <!-- Pagination — sticks to bottom -->
              <div
                *ngIf="reAssessmentData.length > 0"
                class="mt-auto flex items-center justify-between pt-2 border-t border-gray-200 text-xs text-gray-500"
              >
                <span class="text-gray-400"
                  >Items per page:
                  <span class="font-semibold text-gray-600">5</span></span
                >
                <div class="flex items-center gap-1">
                  <span class="text-gray-500 mr-1">
                    <span class="font-semibold text-gray-700"
                      >{{ (reAssessmentPage - 1) * reAssessmentPageSize + 1 }}–{{
                        reAssessmentPage * reAssessmentPageSize <
                        reAssessmentTotalItems
                          ? reAssessmentPage * reAssessmentPageSize
                          : reAssessmentTotalItems
                      }}</span
                    >
                    of {{ reAssessmentTotalItems }}
                  </span>
                  <button
                    class="w-7 h-7 flex items-center justify-center rounded border border-gray-300 bg-white hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    [disabled]="reAssessmentPage === 1"
                    (click)="
                      onReAssessmentPageChange({
                        pageIndex: reAssessmentPage - 2,
                        pageSize: reAssessmentPageSize
                      })
                    "
                  >
                    <mat-icon
                      class="!text-base !w-4 !h-4 leading-none text-gray-600"
                      >chevron_left</mat-icon
                    >
                  </button>
                  <button
                    class="w-7 h-7 flex items-center justify-center rounded border border-gray-300 bg-white hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    [disabled]="
                      reAssessmentPage * reAssessmentPageSize >=
                      reAssessmentTotalItems
                    "
                    (click)="
                      onReAssessmentPageChange({
                        pageIndex: reAssessmentPage,
                        pageSize: reAssessmentPageSize
                      })
                    "
                  >
                    <mat-icon
                      class="!text-base !w-4 !h-4 leading-none text-gray-600"
                      >chevron_right</mat-icon
                    >
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>

<ng-template #noDataTemplate let-text="text">
  <div
    class="w-[80%] absolute shadow-lg rounded-lg p-3 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center z-10 bg-white bg-opacity-95"
  >
    <div class="text-center">
      <mat-icon class="text-gray-400 text-6xl mb-4">visibility_off</mat-icon>
      <h3 class="text-lg font-medium text-gray-900 mb-3 px-16">
        {{ text || "No Records Found" }}
      </h3>
    </div>
  </div>
</ng-template>
